var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ConversationNodeInstruction, InstructionType, } from 'packages/bot/entities/ConversationNodeInstruction';
import { v4 as uuid } from 'uuid';
import { PrivacyPolicyLink } from 'ui/v1/controls/editors/quill/PrivacyPolicyLink';
import Quill from 'quill';
var speechBubbleTailLeft = require('ui/svg/speech-bubble-tail-left.svg?raw');
var speechBubbleTailRight = require('ui/svg/speech-bubble-tail-right.svg?raw');
var BotSpeechBubble = /** @class */ (function (_super) {
    __extends(BotSpeechBubble, _super);
    function BotSpeechBubble() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textValue = null;
        _this.quillId = "quill-" + uuid();
        _this.selectedOptions = [];
        return _this;
    }
    Object.defineProperty(BotSpeechBubble.prototype, "speechBubbleTailLeft", {
        get: function () {
            return speechBubbleTailLeft;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotSpeechBubble.prototype, "speechBubbleTailRight", {
        get: function () {
            return speechBubbleTailRight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotSpeechBubble.prototype, "isUserMessage", {
        get: function () {
            return this.instruction.type === InstructionType.SEND_MESSAGE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotSpeechBubble.prototype, "displayInput", {
        get: function () {
            return (this.instruction.type === InstructionType.COLLECT && !this.value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotSpeechBubble.prototype, "hasTextField", {
        get: function () {
            return this.instruction.type === InstructionType.COLLECT && ['email', 'name', 'text', 'phone'].includes(this.instruction.data.type);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotSpeechBubble.prototype, "instructionRequiresConfirmation", {
        get: function () {
            return this.instruction.data.type !== 'option';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotSpeechBubble.prototype, "isValidEmail", {
        get: function () {
            var _a;
            return ((_a = this.textValue) === null || _a === void 0 ? void 0 : _a.length) > 1 && this.textValue.match(/(\w+[@]+\w+[.]+\w{2})+/g);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotSpeechBubble.prototype, "displayValue", {
        get: function () {
            var _this = this;
            var _a, _b;
            if (this.instruction.type === InstructionType.SEND_MESSAGE) {
                return this.instruction.data.message;
            }
            switch (this.instruction.data.type) {
                case 'text':
                    return this.value;
                case 'option':
                    return (_b = (_a = this.instruction.data.options.find(function (option) { return option.id === _this.value; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : this.value;
                case 'options':
                    if (!this.value)
                        return [];
                    return this.instruction.data.options.filter(function (option) { return _this.value.includes(option.id); }).map(function (option) { return option.label; });
                default:
                    return this.instruction.data.message;
            }
        },
        enumerable: false,
        configurable: true
    });
    BotSpeechBubble.prototype.mounted = function () {
        if (this.instruction.type === InstructionType.SEND_MESSAGE) {
            Quill.register(PrivacyPolicyLink);
            var q = new Quill("#" + this.quillId);
            q.pasteHTML(this.instruction.data.message);
            q.disable();
        }
    };
    BotSpeechBubble.prototype.sendValue = function () {
        var value = this.textValue;
        if (value === null) {
            value = this.instruction.data.type === 'options' ? [] : '';
        }
        this.$emit('send', {
            node_id: this.instruction.node,
            instruction_id: this.instruction.id,
            value: value,
        });
    };
    BotSpeechBubble.prototype.sendOption = function (option) {
        this.textValue = option.id;
        this.sendValue();
    };
    BotSpeechBubble.prototype.toggleOption = function (option) {
        var _this = this;
        var existingOption = this.selectedOptions.findIndex(function (optionId) { return optionId === option.id; });
        if (existingOption >= 0) {
            this.selectedOptions.splice(existingOption, 1);
        }
        else {
            this.selectedOptions.push(option.id);
        }
        // we need to do this instead of a simple `Object.keys` in order to
        // ensure we send the results in the same order as the original
        // options were presented, as to make the result look correct.
        this.textValue = this.instruction.data.options
            .filter(function (existingOption) { return _this.selectedOptions.includes(existingOption.id); })
            .map(function (o) { return o.id; });
    };
    var _a;
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof ConversationNodeInstruction !== "undefined" && ConversationNodeInstruction) === "function" ? _a : Object)
    ], BotSpeechBubble.prototype, "instruction", void 0);
    __decorate([
        Prop({ required: true }),
        __metadata("design:type", String)
    ], BotSpeechBubble.prototype, "color", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], BotSpeechBubble.prototype, "showTail", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], BotSpeechBubble.prototype, "value", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], BotSpeechBubble.prototype, "lang", void 0);
    BotSpeechBubble = __decorate([
        Component
    ], BotSpeechBubble);
    return BotSpeechBubble;
}(Vue));
export default BotSpeechBubble;
